import { render, staticRenderFns } from "./ShippingRuleGuide.vue?vue&type=template&id=9cbdbd3c&scoped=true&"
import script from "./ShippingRuleGuide.vue?vue&type=script&lang=js&"
export * from "./ShippingRuleGuide.vue?vue&type=script&lang=js&"
import style0 from "./ShippingRuleGuide.vue?vue&type=style&index=0&id=9cbdbd3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbdbd3c",
  null
  
)

export default component.exports